import React from 'react';

import styled from 'styled-components';

import ScrollReveal from '@components/common/ScrollReveal';
import { Container } from '@components/parts/Container';
import { IconTDIs } from '@components/parts/IconTDIs';
import { Title } from '@components/parts/Title';

import { TDIs } from '@customTypes/TDI';
import { UploadedImage } from '@customTypes/UploadedImage';

type Props = {
  title: string;
  titleHint: string;
  tdis: TDIs;
  mobileImage: UploadedImage;
  tdisPaddingLeft?: string;
  backgroundColor: string;
  color: string;
};

const Wrapper = styled.div<Props>`
  margin-top: 90px;
  background-color: ${(props) => props.backgroundColor};
  .mobile-image {
    width: 100%;
    flex: 1;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    min-height: 400px;
    margin-top: 50px;
    margin-right: 50px;
  }
  .section {
    display: flex;
    flex-direction: column;
  }
  .IconTDIs {
    display: flex;
    flex: 1;
    .title {
      font-size: 1.7em;
    }
    .description {
      margin-bottom: 30px;
    }
  }
  @media (min-width: 768px) {
    margin-top: 160px;
    background-size: cover;
    background-position: top;
    .section {
      flex-direction: row;
      gap: 80px;
    }
    .mobile-image {
      margin-top: 0;
      flex: 5;
    }
    .IconTDIs {
      flex: 4;
      .title {
        white-space: nowrap;
        font-size: 36px;
      }
      .description {
        font-size: 20px;
        margin-bottom: 2.8em !important;
      }
    }
  }
`;

export const FullImageSection: React.FC<Props> = (props) => {
  const { titleHint, title, tdis, mobileImage, color } = props;

  return (
    <Wrapper {...props}>
      <Title titleHint={titleHint} title={title} backgroundColor="transparent" color={color} />
      <ScrollReveal>
        <Container>
          <div className="section">
            {mobileImage?.data?.attributes?.url ? (
              <div className="mobile-image" style={{ backgroundImage: `url('${mobileImage.data.attributes.url}')` }} />
            ) : null}
            <IconTDIs noContainer forceColumn tdis={tdis} backgroundColor="transparent" color={color} />
          </div>
        </Container>
      </ScrollReveal>
    </Wrapper>
  );
};
